import * as React from 'react';
export const stopFilledSvg = React.forwardRef(function stopFilledSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1 2.5A1.5 1.5 0 0 1 2.5 1h7A1.5 1.5 0 0 1 11 2.5v7A1.5 1.5 0 0 1 9.5 11h-7A1.5 1.5 0 0 1 1 9.5v-7Z',
    }),
  );
});
stopFilledSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var stopFilled = {
  category: 'icon',
  colorable: true,
  name: 'stopFilled',
  svg: stopFilledSvg,
};
